<div class="container-modal-lateral container-modal-lateral--canal">
  <div class="container-modal-lateral__conteudo">
    <span class="title-modal-lateral">{{visualizar ? "Detalhes Canal" : "Cadastrar Canal"}}</span>

    @if (carregandoModal) {
      <div class="modal-skeleton">
        <div class="modal-skeleton__coluna">
          <div class="modal-skeleton__linha modal-skeleton__linha--title"></div>
          <div class="modal-skeleton__card"></div>
          <div class="modal-skeleton__section"></div>
          <div class="modal-skeleton__card"></div>
          <div class="modal-skeleton__section"></div>
          <div class="modal-skeleton__card"></div>
          <div class="modal-skeleton__section"></div>
          <div class="modal-skeleton__section"></div>
          <div class="modal-skeleton__section"></div>
          <div class="modal-skeleton__card"></div>
          <div class="modal-skeleton__card modal-skeleton__card--alto"></div>
        </div>
        <div class="modal-skeleton__divisor"></div>
        <div class="modal-skeleton__coluna">
          <div class="modal-skeleton__section"></div>
          <div class="modal-skeleton__card"></div>
          <div class="modal-skeleton__section"></div>
          <div class="modal-skeleton__card"></div>
          <div class="modal-skeleton__card"></div>
          <div class="modal-skeleton__section"></div>
          <div class="modal-skeleton__card"></div>
          <div class="modal-skeleton__section"></div>
          <div class="modal-skeleton__section"></div>
          <div class="modal-skeleton__card"></div>
        </div>
      </div>
    } @else {
    <div class="container-modal-lateral__colunas">
      <div class="coluna-esquerda">

        @if (!visualizar) {
          <div class="main-modal-lateral-edicao main-modal-lateral-edicao--compacta">
            @if (canal.id) {
              <app-slide-toggle-padrao [valor]="canal.ativo"
                (changeValue)="canal.ativo = $event; alteracaoService.camposAlterado()"></app-slide-toggle-padrao>
            }
            <app-form-field
              label="Nome"
              heightFormField="35px"
              [value]="canal.nome"
              [font]="'12px'"
              (changeValue)="canal.nome = $event; alteracaoService.camposAlterado()"
              [max]="20"></app-form-field>

            <app-form-field
              label="Descrição"
              heightFormField="35px"
              [value]="canal.descricao"
              [font]="'12px'"
              (changeValue)="canal.descricao = $event; alteracaoService.camposAlterado()"
            ></app-form-field>
          </div>

          <div class="container-info-modal-lateral">
            <span class="label">Canal é externo?</span>
            @if(!visualizar){
              <app-form-field style="width: calc(100% - 5px)" [disabled]="!visualizar" [isCheckbox]="true" [value]="canal.externo" (changeValue)="onChangeExterno($event)"></app-form-field>
            }
            @else{
              <span>{{canal.externo ? 'Sim' : 'Não'}}</span>
            }
          </div>

          <div class="topico-modal-lateral">
            <span class="label">Coordenadores</span>
          </div>

          <div class="main-modal-lateral-edicao">
            <app-select-multiple
              [listaInput]="usuarios"
              [itensSelecionado]="canal.coordenadores"
              [disabled]="canal.externo ? true : false"
              [font]="'12px'"
              heightFormField="35px"
              campo="nome"
              (selecionarItem)="atualizarCoordenadores($event)"
              colorLabel="black"
              label="Vincular Coordenadores"></app-select-multiple>

            <div class="align-operador">
              @for (coordenador of canal.coordenadores; track coordenador.id){
                <span class="font-12 flex justify-content: flex-start align-center flex-row" style="width: 100%; margin-bottom: 8px;">
                  <div class="flex align-center gap-5">
                    @if (coordenador.extensaoImg && coordenador.uuid){
                      <img class="icones circulo" [src]="gerarUrl(coordenador.uuid, coordenador.extensaoImg, 'usuario-img')" [alt]="'Foto de ' + coordenador.nome" />
                    } @else {
                      <img class="icones" src="./assets/icones/no-img-default.png" alt="" />
                    }
                    <span>{{ coordenador.nome }}</span>
                  </div>
                  <img class="icones cursor-pointer" src="./assets/icones/delete-forever.svg" style="margin-left: auto;" alt="Remover coordenador"
                    tabindex="0" role="button"
                    (click)="removerCoordenador(coordenador.id!); alteracaoService.camposAlterado()"
                    (keydown.enter)="removerCoordenador(coordenador.id!); alteracaoService.camposAlterado()" />
                </span>
              }
            </div>
          </div>

          <div class="topico-modal-lateral">
            <span class="label">Operadores</span>
          </div>

          <div class="main-modal-lateral-edicao">
            <app-select-multiple
              [listaInput]="operadores"
              [itensSelecionado]="canal.operadores"
              [disabled]="canal.externo ? true : false"
              [font]="'12px'"
              heightFormField="35px"
              campo="nome"
              (selecionarItem)="atualizarOperadores($event)"
              colorLabel="black"
              label="Vincular Operadores"></app-select-multiple>

            <div class="align-operador">
              @for (operador of canal.operadores; track operador.id){
                <span class="font-12 flex justify-content: flex-start align-center flex-row" style="width: 100%; margin-bottom: 8px;">
                  <div class="flex align-center gap-5">
                    @if (operador.extensaoImg && operador.imgBase64){
                      <img class="icones circulo" [src]="gerarUrl(operador.imgBase64, operador.extensaoImg, 'usuario-img')" [alt]="'Foto de ' + operador.nome" />
                    } @else {
                      <img class="icones" src="./assets/icones/no-img-default.png" alt="" />
                    }
                    <span>{{ operador.nome }}</span>
                  </div>
                  <img class="icones cursor-pointer" src="./assets/icones/delete-forever.svg" style="margin-left: auto;" alt="Remover operador"
                    tabindex="0" role="button"
                    (click)="removerOperadores(operador.id!); alteracaoService.camposAlterado()"
                    (keydown.enter)="removerOperadores(operador.id!); alteracaoService.camposAlterado()" />
                </span>
              }
            </div>
          </div>

          <div class="topico-modal-lateral">
            <span class="label">Templates</span>
          </div>

          <div class="main-modal-lateral-edicao">
            <app-select-multiple
              [listaInput]="templates"
              [itensSelecionado]="canal.templates"
              [disabled]="canal.externo ? true : false"
              [font]="'12px'"
              heightFormField="35px"
              campo="name"
              (selecionarItem)="atualizarTemplates($event)"
              colorLabel="black"
              label="Adicionar Templates"></app-select-multiple>
            <div class="flex-direction-column gap-5 margin-top-10 alinhamento">
              @for (template of canal.templates; track template.id){
                <div class="font-11 flex justify-content: flex-start align-center" style="width: 100%; margin-bottom: 8px;">
                  <div class="flex-direction-column gap-10">
                    <span class="font-12 weight-400">{{ template.name ?? '--' }}</span>
                    <span class="font-10 weight-400">{{ template.numero?.numero ? (template.numero.numero | celularMask) : '--' }}</span>
                  </div>
                  <img class="icones cursor-pointer"
                  src="./assets/icones/delete-forever.svg" style="margin-left: auto;" alt="Remover template"
                    tabindex="0" role="button"
                    (click)="removerTemplates(template.id); alteracaoService.camposAlterado()"
                    (keydown.enter)="removerTemplates(template.id); alteracaoService.camposAlterado()" />
                </div>
              }
            </div>
          </div>
        } @else {
          <div class="main-modal-lateral-info">
            <div class="container-info-modal-lateral">
              <span class="label">Status</span>
              <span class="font-12">{{ canal.ativo ? "Ativo" : "Inativo" }}</span>
            </div>

            <div class="container-info-modal-lateral">
              <span class="label">Nome</span>
              <span class="font-12">{{ canal.nome }}</span>
            </div>

            <div class="topico-modal-lateral">
              <span class="label">Coordenadores</span>
            </div>

            <div class="container-info-modal-lateral">
              <span class="label">Coordenadores</span>
              <div class="align-operador">
                @for (coordenador of canal.coordenadores; track coordenador.id){
                  <span class="font-12 ellipse flex justify-between align-center">
                    <div class="flex align-center gap-5">
                      @if (coordenador.extensaoImg && coordenador.uuid){
                        <img class="icones circulo" [src]="gerarUrl(coordenador.uuid, coordenador.extensaoImg, 'usuario-img')" [alt]="'Foto de ' + coordenador.nome" />
                      } @else {
                        <img class="icones" src="./assets/icones/no-img-default.png" alt="" />
                      }
                      {{ coordenador.nome }}
                    </div>
                  </span>
                }
              </div>
            </div>

            <div class="topico-modal-lateral">
              <span class="label">Operadores</span>
            </div>

            <div class="container-info-modal-lateral">
              <span class="label">Operadores</span>
              <div class="align-operador">
                @for (operador of canal.operadores; track operador.id){
                  <span class="font-12 ellipse flex justify-between align-center">
                    <div class="flex align-center gap-5">
                      @if (operador.extensaoImg && operador.imgBase64){
                        <img class="icones circulo" [src]="gerarUrl(operador.imgBase64, operador.extensaoImg, 'usuario-img')" [alt]="'Foto de ' + operador.nome" />
                      } @else {
                        <img class="icones" src="./assets/icones/no-img-default.png" alt="" />
                      }
                      {{ operador.nome }}
                    </div>
                  </span>
                }
              </div>
            </div>

            <div class="topico-modal-lateral">
              <span class="label">Templates</span>
            </div>

            <div class="container-info-modal-lateral">
              <div class="flex-direction-column gap-5">
                @for (template of canal.templates; track template.id){
                  <div class="font-12 ellipse flex justify-between align-center">
                    <div class="flex-direction-column gap-5">
                      <span>Nome do Template</span>
                      <span>{{ template.name }}</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>

      <div class="coluna-direita">
        <app-inatividade-canal
          [periodos]="periodosInatividade"
          [inatividadeAtiva]="inatividadeAtiva"
          [readOnly]="visualizar"
          (periodosChange)="atualizarPeriodosInatividade($event)"
          (inatividadeAtivaChange)="atualizarInatividadeAtiva($event)">
        </app-inatividade-canal>

        <app-horario-funcionamento
          [horarios]="horariosFuncionamento"
          [mensagemInatividadeFuncionamento]="mensagemInatividadeFuncionamento"
          [readOnly]="visualizar"
          (horariosChange)="atualizarHorariosFuncionamento($event)"
          (mensagemInatividadeFuncionamentoChange)="atualizarMensagemInatividadeFuncionamento($event)"
        ></app-horario-funcionamento>

        <div class="topico-modal-lateral">
          <span class="label">Privacidade</span>
        </div>

        <div class="container-info-modal-lateral">
          <span class="label">Canal é privado?</span>
          @if(!visualizar){
            <app-form-field style="width: calc(100% - 5px)" [disabled]="!visualizar" [isCheckbox]="true" [value]="canal.privado" (changeValue)="canal.privado= $event; alteracaoService.camposAlterado()"></app-form-field>
          }
          @else{
            <span>{{canal.privado ? 'Sim' : 'Não'}}</span>
          }
        </div>

      </div>
    </div>
    }
  </div>

  @if (!visualizar && !carregandoModal) {
    <div class="botoes-modal-lateral center-center">
      <div class="center-center flex-direction-row-reverse gap-5" style="width: 30vw;">
        <app-button-padrao
          style="width: 100%;"
          [width]="'100%'"
          label="Salvar"
          backgroundColor="var(--verde-padrao)"
          color="white"
          (buttonClick)="salvar()"></app-button-padrao>
        <app-button-padrao
          style="width: 100%;"
          [width]="'100%'"
          label="Cancelar"
          backgroundColor="white"
          color="var(--vermelho-padrao)"
          (buttonClick)="cancelar()"
          borderColor="var(--vermelho-padrao)"
          borderStyle="solid"
          borderWidth="1px"></app-button-padrao>
      </div>
    </div>
  }
</div>
